export const injectedData = (app) => {
    // added fallback for auto completion
    app.config.globalProperties.$injectedData = window.injectedData || {
        change_status: {ALL:"-1",WIP:"1",APPROVED:"2",CANCELED:"3"},
    };
}

export default injectedData;
